module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// /Users/abuldauskas/nonwork/walt/packages/walt-compiler/node_modules/babel-runtime/node_modules/core-js/library/modules/_redefine.js
// module id = 958
// module chunks = 0